import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import UploadIcon from '@material-ui/icons/CloudUpload';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import LineStyle from '@material-ui/icons/LineStyle';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CopyIcon from '@material-ui/icons/FileCopy';
import TextField from '@material-ui/core/TextField';
import DataTable from './shared/DataTable';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {CompactPicker} from 'react-color';
import environment from '../environments';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dropzone from 'react-dropzone'
import 'react-trumbowyg/dist/trumbowyg.min.css'
import Trumbowyg from 'react-trumbowyg'
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {observer} from "mobx-react";
import {Link} from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import {Card} from "@material-ui/core";

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
    },
    iconSmall: {
        fontSize: 20,
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 170
    },
    card: {
        maxWidth: 300,
    },
    media: {
        height: 300,
    },
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        textAlign: 'center'
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    warningButton: {
        margin: theme.spacing.unit,
        color: "white",
        backgroundColor: "#E9190F",
        '&:hover': {
            backgroundColor: "#E9190F",
        },
    },
    buttonProgress: {
        color: '#D64D29',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    appBar: {
        backgroundColor: 'white',
        top: 'auto',
        bottom: 0,
    }
});

class ProductDetails extends Component
{

    constructor(props)
    {
        super(props);
        this.tableColumns = [
            {name: "ID", field: "identifier", sortable: false},
            {name: "Beschreibung", field: "title", sortable: false},
            {name: "Anzahl Scans", field: "scans", sortable: false},
            {name: "Aktiviert", field: "granted", type: "date", sortable: false},
            {name: "Produkt", field: "icon_key", type: "image", sortable: false},
        ]

        this.state = {
            deleteModal: false,
            safetyCheckWord: '',
            safetyCheckPassed: false
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSafetyCheckInputChange = this.handleSafetyCheckInputChange.bind(this);
        this.handleLayoutChange = this.handleLayoutChange.bind(this);
        this.handleHTMLEditorBlur = this.handleHTMLEditorBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal()
    {
        this.setState({
            deleteModal: !this.state.deleteModal,
        });
    }

    handleLayoutChange(event)
    {
        const target = event.target;
        let position = target.name.replace('layout-', '');
        let layout = this.props.productStore.product.layout;

        layout[parseInt(position, 10)] = parseInt(target.value, 10);

        this.props.productStore.product.layout = layout;
    }

    handleInputChange(event)
    {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.props.productStore.product[name] = value;
    }

    handleHTMLEditorBlur = (value) =>
    {
        this.props.productStore.product.landingpage_intro = value.target.innerHTML;
    };

    handleSafetyCheckInputChange(event)
    {
        const target = event.target;
        const value = target.value;
        this.setState({safetyCheckWord: value})
        if (value === this.props.productStore.product.productid)
        {
            this.setState({safetyCheckPassed: true})
        } else
        {
            this.setState({safetyCheckPassed: false})
        }
    }

    deleteProduct()
    {
        this.props.productStore.deleteProduct(this.props.match.params.id);
    }

    handleDuplicateProduct()
    {
        this.props.productStore.duplicateProduct(this.props.match.params.id);
    }

    handleSubmit(event)
    {
        this.props.productStore.saveProduct(this.props.match.params.id);
        event.preventDefault();
    }

    handleFgColorChangeComplete = (color) =>
    {
        this.props.productStore.product.foreground_color = color.hex;
    };

    handleBgColorChangeComplete = (color) =>
    {
        this.props.productStore.product.background_color = color.hex;
    };

    handleButtonColorChangeComplete = (color) =>
    {
        this.props.productStore.product.button_color = color.hex;
    };

    handleButtonTextColorChangeComplete = (color) =>
    {
        this.props.productStore.product.button_text_color = color.hex;
    };

    handleLabelColorChangeComplete = (color) =>
    {
        this.props.productStore.product.label_color = color.hex;
    };

    handleDelimiterColorChangeComplete = (color) =>
    {
        this.props.productStore.product.delimiter_color = color.hex;
    };

    handleQrCodeColorChangeComplete = (color) =>
    {
        this.props.productStore.product.qrcode_color = color.hex;
    };

    handleIdentifierColorChangeComplete = (color) =>
    {
        this.props.productStore.product.identifier_color = color.hex;
    };

    handleLogoColorChangeComplete = (color) =>
    {
        this.props.productStore.product.logo_color = color.hex;
    };

    componentDidMount()
    {
        this.props.productStore.getProduct(this.props.match.params.id);
    }

    componentDidUpdate(prevProps)
    {
        /* The route stays mounted when switching products (e.g. after duplicating) */
        if (prevProps.match.params.id !== this.props.match.params.id)
        {
            this.props.productStore.getProduct(this.props.match.params.id);
        }
    }

    uploadFile(type)
    {
        this.props.productStore.upload(this.props.match.params.id, type)
    }

    render()
    {
        const {classes} = this.props;

        return (
            <div>
                <ToastContainer/>
                <Dialog
                    open={this.state.deleteModal}
                    onClose={this.toggleModal}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">Produkt löschen</DialogTitle>
                    <DialogContent>
                        Um das Produkt <strong>{this.props.productStore.product.name}</strong> endgültig zu löschen, bestätige den Vorgang durch Eingabe der
                        Produktnummer <strong>{this.props.productStore.product.productid}</strong>.
                        <br/>
                        <TextField
                            id="productnumber"
                            name="productnumber"
                            label="Produktnummer"
                            className={classes.textField}
                            value={this.state.safetyCheckWord}
                            onChange={this.handleSafetyCheckInputChange}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                            fullWidth={true}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" size="small" color="primary" onClick={this.toggleModal} className={classes.button}>
                            <CancelIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Abbrechen
                        </Button>
                        <Button variant="contained" size="small" color="secondary" onClick={() => this.deleteProduct()} className={classes.warningButton}
                                disabled={!this.state.safetyCheckPassed}>
                            <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                            Löschen
                        </Button>
                    </DialogActions>
                </Dialog>
                <Typography variant="title" gutterBottom>
                    Produktnummer: {this.props.productStore.product.productid}
                </Typography>
                <form noValidate autoComplete="off">
                    <Grid container spacing={16}>
                        <Grid item lg={2}>
                            <TextField
                                id="name"
                                name="name"
                                label="Name"
                                value={this.props.productStore.product.name || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}
                            />
                        </Grid>
                        <Grid item lg={2}>
                            <TextField
                                id="productid"
                                name="productid"
                                label="Produktnummer"
                                value={this.props.productStore.product.productid || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}
                                disabled
                            />
                        </Grid>
                        <Grid item lg={2}>
                            <TextField
                                id="created_by"
                                label="Erstellt von"
                                value={this.props.productStore.product.created_by || ''}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                onClick={() =>
                                {
                                    (this.props.productStore.product.created_by && this.props.productStore.product.created_by !== '') ?
                                        this.props.history.push("/users/" + this.props.productStore.product.created_by) : alert("Keine gültige Benutzerkennung")
                                }}
                                fullWidth={true}
                                disabled
                            />
                        </Grid>
                        <Grid item lg={2}>
                            <TextField
                                id="updated_by"
                                label="Zuletzt bearbeitet von"
                                value={this.props.productStore.product.updated_by || ''}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                onClick={() =>
                                {
                                    (this.props.productStore.product.updated_by && this.props.productStore.product.updated_by !== '') ?
                                        this.props.history.push("/users/" + this.props.productStore.product.updated_by) : alert("Keine gültige Benutzerkennung")
                                }}
                                fullWidth={true}
                                disabled
                            />
                        </Grid>
                    </Grid>
                    <hr/>
                    <Typography variant="subheading" gutterBottom>
                        Funktionen
                    </Typography>
                    <Grid container spacing={16}>
                        <Grid item lg={2}>
                            <TextField
                                id="linkable"
                                name="linkable"
                                select
                                label="Verlinkung möglich"
                                value={this.props.productStore.product.linkable || 0}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                        </Grid>
                        <Grid item lg={2}>
                            <TextField
                                id="landingpage"
                                name="landingpage"
                                select
                                label="Infoseite möglich"
                                value={this.props.productStore.product.landingpage || 0}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                        </Grid>
                        <Grid item lg={2}>
                            <TextField
                                id="location"
                                name="location"
                                select
                                label="Standort möglich"
                                value={this.props.productStore.product.location || 0}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                        </Grid>
                        <Grid item lg={2}>
                            <TextField
                                id="trackable"
                                name="trackable"
                                select
                                label="Tracking möglich"
                                value={this.props.productStore.product.trackable || 0}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}
                                disabled>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                        </Grid>
                    </Grid>
                    <Grid container spacing={16}>
                        <Grid item lg={2}>
                            <TextField
                                id="shop_url_visible"
                                name="shop_url_visible"
                                select
                                label="Link zum Shop in App"
                                value={this.props.productStore.product.shop_url_visible || 0}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                        </Grid>
                        <Grid item lg={2}>
                            <TextField
                                id="shop_url_landingpage_visible"
                                name="shop_url_landingpage_visible"
                                select
                                label="Link zum Shop auf Infoseite"
                                value={this.props.productStore.product.shop_url_landingpage_visible || 0}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                        </Grid>
                        <Grid item lg={4}>
                            <TextField
                                id="shop_url"
                                name="shop_url"
                                label="Shop-Adresse (zum Nachbestellen)"
                                value={this.props.productStore.product.shop_url || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={16} style={{marginBottom: 30}}>
                        <Grid item lg={2}>
                            <TextField
                                id="help_url_visible"
                                name="help_url_visible"
                                select
                                label="Link zur Hilfe in App"
                                value={this.props.productStore.product.help_url_visible || 0}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                        </Grid>
                        <Grid item lg={6}>
                            <TextField
                                id="help_url"
                                name="help_url"
                                label="Hilfe-Adresse (z.B. YouTube Video, Website)"
                                value={this.props.productStore.product.help_url || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}
                            />
                        </Grid>
                    </Grid>
                    <hr/>
                    <Typography variant="subheading" gutterBottom>
                        Darstellung Infoseite, Blankoseite und App
                    </Typography>
                    <Grid container spacing={16} style={{marginBottom: 10}}>
                        <Grid item>
                            <Typography variant="body1" gutterBottom>
                                Schriftfarbe
                            </Typography>
                            <CompactPicker color={this.props.productStore.product.foreground_color || '#FF0000'}
                                           onChangeComplete={this.handleFgColorChangeComplete}/>
                            <hr/>
                            <Typography variant="body1" gutterBottom>
                                Hintergrundfarbe
                            </Typography>
                            <CompactPicker color={this.props.productStore.product.background_color || '#FF0000'}
                                           onChangeComplete={this.handleBgColorChangeComplete}/>
                            <hr/>
                            <Typography variant="body1" gutterBottom>
                                Labelfarbe
                            </Typography>
                            <CompactPicker color={this.props.productStore.product.label_color || '#FF0000'}
                                           onChangeComplete={this.handleLabelColorChangeComplete}/>
                            <hr/>
                            <Typography variant="body1" gutterBottom>
                                Trennstrichfarbe
                            </Typography>
                            <CompactPicker color={this.props.productStore.product.delimiter_color || '#FF0000'}
                                           onChangeComplete={this.handleDelimiterColorChangeComplete}/>
                        </Grid>
                        <Grid item>
                            <Typography variant="body1" gutterBottom>
                                Buttonfarbe
                            </Typography>
                            <CompactPicker color={this.props.productStore.product.button_color || '#FF0000'}
                                           onChangeComplete={this.handleButtonColorChangeComplete}/>
                            <hr/>
                            <Typography variant="body1" gutterBottom>
                                Button Textfarbe
                            </Typography>
                            <CompactPicker color={this.props.productStore.product.button_text_color || '#FF0000'}
                                           onChangeComplete={this.handleButtonTextColorChangeComplete}/>
                            <hr/>
                            <TextField
                                id="button_text"
                                name="button_text"
                                label="Button Text"
                                value={this.props.productStore.product.button_text || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}
                            />
                            <br/>
                            <TextField
                                id="show_ads"
                                name="show_ads"
                                select
                                label="Werbung auf Infoseite einblenden"
                                value={this.props.productStore.product.show_ads || 0}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                            <br/>
                            <TextField
                                id="blankpage_layout"
                                name="blankpage_layout"
                                select
                                label="Gleiches Layout für Blankoseite"
                                value={this.props.productStore.product.blankpage_layout || 0}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}>
                                <option value="1">Ja</option>
                                <option value="0">Nein</option>
                            </TextField>
                            <br/>
                            <TextField
                                id="redirect_description"
                                name="redirect_description"
                                label="Beschreibung für Verlinkung"
                                value={this.props.productStore.product.redirect_description || ''}
                                onChange={this.handleInputChange}
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                fullWidth={true}
                            />
                        </Grid>
                        <Grid item>
                            <Typography variant="body1" gutterBottom>
                                Intro-Text
                            </Typography>
                            <Trumbowyg
                                id='react-trumbowyg'
                                data={this.props.productStore.product.landingpage_intro || ""}
                                onBlur={this.handleHTMLEditorBlur}
                                buttons={[
                                    ['formatting'],
                                    ['strong', 'em', 'del'],
                                    ['link'],
                                    ['insertImage'],
                                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                                    ['unorderedList', 'orderedList'],
                                    ['horizontalRule'],
                                ]}
                            />
                        </Grid>
                        {/** TODO: AB hier kaputt */}
                        <Grid item>
                            <Typography variant="body1" gutterBottom>
                                Banner
                            </Typography>
                            <Paper className={classes.paper}>
                                <img width="180"
                                     src={this.props.productStore.product.banner_key ? environment.CDN_HOST + "/" + this.props.productStore.product.banner_key :
                                         require('../assets/img/banner-placeholder.png')} alt="Icon klein"/>
                                <Dropzone onDrop={(accepted) =>
                                {
                                    this.props.productStore.bannerFile = accepted[0]
                                }}
                                          className="justify-content-center align-items-center"
                                          style={null}>
                                    {({getRootProps, getInputProps}) => (
                                        <Card style={{padding: "5px", margin: "5px", textAlign: 'center'}}>
                                            <div {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                {!this.props.productStore.bannerFile.name ? (
                                                    <Typography variant="caption" gutterBottom align="center">
                                                        Datei hineinziehen oder klicken
                                                    </Typography>
                                                ) : (
                                                    <Typography variant="caption" gutterBottom align="center">
                                                        {this.props.productStore.bannerFile.name} ({this.props.productStore.bannerFile.size} bytes)
                                                    </Typography>
                                                )}
                                            </div>
                                        </Card>
                                    )}
                                </Dropzone>
                                <div className={classes.wrapper}>
                                    <Button size="small" variant="contained" color="primary" onClick={() =>
                                    {
                                        this.uploadFile("banner")
                                    }} disabled={this.props.productStore.uploading}>
                                        <UploadIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Hochladen
                                    </Button>
                                    {this.props.productStore.uploading && <CircularProgress size={24} className={classes.buttonProgress}/>}
                                </div>
                            </Paper>
                            <hr/>
                            <Typography variant="body1" gutterBottom>
                                App-Logo
                            </Typography>
                            <Paper className={classes.paper}>
                                <img width="120" height="120"
                                     src={this.props.productStore.product.icon_key ? environment.CDN_HOST + "/" + this.props.productStore.product.icon_key :
                                         require('../assets/img/logo-placeholder.png')} alt="Icon klein"/>
                                <Dropzone onDrop={(accepted) =>
                                {
                                    this.props.productStore.lpIconFile = accepted[0]
                                }}
                                          className="justify-content-center align-items-center"
                                          style={null}>
                                    {({getRootProps, getInputProps}) => (
                                        <Card style={{padding: "5px", margin: "5px", textAlign: 'center'}}>
                                            <div {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                {!this.props.productStore.lpIconFile.name ? (
                                                    <Typography variant="caption" gutterBottom align="center">
                                                        Datei hineinziehen oder klicken
                                                    </Typography>
                                                ) : (
                                                    <Typography variant="caption" gutterBottom align="center">
                                                        {this.props.productStore.lpIconFile.name} ({this.props.productStore.lpIconFile.size} bytes)
                                                    </Typography>
                                                )}
                                            </div>
                                        </Card>
                                    )}
                                </Dropzone>
                                <div className={classes.wrapper}>
                                    <Button size="small" variant="contained" color="primary" onClick={() =>
                                    {
                                        this.uploadFile("icon")
                                    }} disabled={this.props.productStore.uploading}>
                                        <UploadIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Hochladen
                                    </Button>
                                    {this.props.productStore.uploading && <CircularProgress size={24} className={classes.buttonProgress}/>}
                                </div>
                            </Paper>
                        </Grid>
                    </Grid>
                    <hr/>
                    <Typography variant="subheading" gutterBottom>
                        Darstellung gedruckter Sticker
                    </Typography>
                    <Grid container spacing={16} style={{marginBottom: 10}}>
                        <Grid item>
                            <Grid container
                                  direction="column"
                                  justify="flex-start"
                                  alignItems="flex-start"
                                  spacing={16} style={{marginBottom: 10}}>
                                <Grid item lg={12}>
                                    <Typography variant="body1" gutterBottom>
                                        Farbe der QR-Codes
                                    </Typography>
                                    <CompactPicker color={this.props.productStore.product.qrcode_color || '#000000'}
                                                   onChangeComplete={this.handleQrCodeColorChangeComplete}/>
                                    <hr/>
                                    <Typography variant="body1" gutterBottom>
                                        Farbe der gedruckten Sticker-ID
                                    </Typography>
                                    <CompactPicker color={this.props.productStore.product.identifier_color || '#000000'}
                                                   onChangeComplete={this.handleIdentifierColorChangeComplete}/>
                                    <br/>
                                    <TextField
                                        id="print_identifier"
                                        name="print_identifier"
                                        select
                                        label="ID auf Sticker drucken"
                                        value={this.props.productStore.product.print_identifier || 0}
                                        onChange={this.handleInputChange}
                                        SelectProps={{
                                            native: true,
                                            MenuProps: {
                                                className: classes.menu,
                                            },
                                        }}
                                        margin="normal"
                                        InputLabelProps={{shrink: true}}
                                        fullWidth={true}>
                                        <option value="1">Ja</option>
                                        <option value="0">Nein</option>
                                    </TextField>
                                    <hr/>
                                    <Typography variant="body1" gutterBottom>
                                        Farbe des Logos in der Mitte
                                    </Typography>
                                    <CompactPicker color={this.props.productStore.product.logo_color || '#F25E0D'}
                                                   onChangeComplete={this.handleLogoColorChangeComplete}/>
                                    <br/>
                                    <TextField
                                        id="print_logo"
                                        name="print_logo"
                                        select
                                        label="Logo in die Mitte drucken"
                                        value={this.props.productStore.product.print_logo || 0}
                                        onChange={this.handleInputChange}
                                        SelectProps={{
                                            native: true,
                                            MenuProps: {
                                                className: classes.menu,
                                            },
                                        }}
                                        margin="normal"
                                        InputLabelProps={{shrink: true}}
                                        fullWidth={true}>
                                        <option value="1">Ja</option>
                                        <option value="0">Nein</option>
                                    </TextField>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item lg={7}>
                            <Typography variant="subtitle1" gutterBottom>
                                Template
                            </Typography>
                            <Paper className={classes.paper}>
                                {this.props.productStore.product.template_key &&
                                    <div>
                                        <object data={environment.CDN_HOST + "/" + this.props.productStore.product.template_key ||
                                            require('../assets/img/template-placeholder.pdf')} style={{height: "700px", width: "100%"}}>
                                            <a href={environment.CDN_HOST + "/" + this.props.productStore.product.template_key ||
                                                require('../assets/img/template-placeholder.pdf')} download>PDF laden</a>
                                        </object>
                                    </div>
                                }
                                <Dropzone onDrop={(accepted) =>
                                {
                                    this.props.productStore.templateFile = accepted[0]
                                }} className="justify-content-center align-items-center" style={null}>
                                    {({getRootProps, getInputProps}) => (
                                        <Card style={{padding: "5px", margin: "5px", textAlign: 'center'}}>
                                            <div {...getRootProps()}>
                                                <input {...getInputProps()} />
                                                {!this.props.productStore.templateFile.name ? (
                                                    <Typography variant="caption" gutterBottom align="center">
                                                        Datei hineinziehen oder klicken
                                                    </Typography>
                                                ) : (
                                                    <Typography variant="caption" gutterBottom align="center">
                                                        {this.props.productStore.templateFile.name} ({this.props.productStore.templateFile.size} bytes)
                                                    </Typography>
                                                )}
                                            </div>
                                        </Card>
                                    )}
                                </Dropzone>
                                <div className={classes.wrapper}>
                                    <Button size="small" variant="contained" color="primary" onClick={() =>
                                    {
                                        this.uploadFile("template")
                                    }} disabled={this.props.productStore.uploading}>
                                        <UploadIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Hochladen
                                    </Button>
                                    {this.props.productStore.uploading && <CircularProgress size={24} className={classes.buttonProgress}/>}
                                </div>
                            </Paper>
                        </Grid>
                        <Grid item lg={2}>
                            <Typography variant="subtitle1" gutterBottom>
                                Belegung
                            </Typography>
                            <TextField
                                id="stickers_per_page"
                                name="stickers_per_page"
                                select
                                label="Sticker pro Seite"
                                className={classes.textField}
                                value={this.props.productStore.product.stickers_per_page || '1'}
                                onChange={this.handleInputChange}
                                SelectProps={{
                                    native: true,
                                    MenuProps: {
                                        className: classes.menu,
                                    },
                                }}
                                margin="normal"
                                InputLabelProps={{shrink: true}}>
                                {this.props.productStore.sppInput.map(spp =>
                                    <option key={spp}>{spp}</option>
                                )}
                            </TextField>
                            {this.props.productStore.layoutOptions.map((option, index) =>
                                <TextField
                                    key={index}
                                    id={"layout-" + index}
                                    name={"layout-" + index}
                                    select
                                    label={"Feld " + option}
                                    className={classes.textField}
                                    value={this.props.productStore.product.layout ? this.props.productStore.product.layout[index] : 1}
                                    onChange={this.handleLayoutChange}
                                    SelectProps={{
                                        native: true,
                                        MenuProps: {
                                            className: classes.menu,
                                        },
                                    }}
                                    margin="normal"
                                    InputLabelProps={{shrink: true}}>
                                    {this.props.productStore.layoutOptions.map((option, index) =>
                                        <option key={index} value={option}>{option}</option>
                                    )}
                                </TextField>
                            )}
                        </Grid>
                    </Grid>
                    <hr/>
                    <Typography variant="subheading" gutterBottom>
                        Sticker im Umlauf
                    </Typography>
                    <Grid container spacing={16}>
                        <DataTable
                            store={this.props.productStore}
                            detailRoute="/stickers"
                            rows={this.props.productStore.product.stickerList}
                            columns={this.tableColumns}
                            history={this.props.history}
                        />
                    </Grid>
                    <AppBar position="fixed" color="primary" className={classes.appBar}>
                        <Toolbar>
                            <Grid
                                container
                                direction="row"
                                justify="flex-end"
                                alignItems="flex-start">
                                <Grid item>
                                    <Button variant="contained" size="small" color="default" onClick={() => this.toggleModal()}
                                            className={classes.warningButton}>
                                        <DeleteIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Löschen
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" size="small" color="primary" onClick={() => this.handleDuplicateProduct()}
                                            className={classes.button}>
                                        <CopyIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Duplizieren
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Link
                                        role="button"
                                        to={{pathname: this.props.location.pathname + "/landingpage", state: {productId: this.props.match.params.id}}}>
                                        <Button variant="contained" size="small" color="primary" className={classes.button}
                                                disabled={!+this.props.productStore.product.landingpage}>
                                            <LineStyle className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                            Eingabefelder
                                        </Button>
                                    </Link>
                                </Grid>
                                <Grid item>
                                    <Link
                                        role="button"
                                        to={{pathname: this.props.location.pathname + "/blankpage", state: {productId: this.props.match.params.id}}}>
                                        <Button variant="contained" size="small" color="primary" className={classes.button}>
                                            <CheckBoxOutlineBlankIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                            Blankoseite
                                        </Button>
                                    </Link>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" size="small" color="secondary" onClick={this.handleSubmit.bind(this)} className={classes.button}
                                            disabled={this.props.productStore.uploading}>
                                        <SaveIcon className={classnames(classes.leftIcon, classes.iconSmall)}/>
                                        Speichern
                                    </Button>
                                </Grid>
                            </Grid>
                            <div className={classes.grow}/>
                        </Toolbar>
                    </AppBar>
                </form>
            </div>
        );
    }
}

export default withStyles(styles)(observer(ProductDetails));
